// Constants used across Dashboard components
export const MOBILE_BREAKPOINT = "md" as const
export const LOADING_HEIGHT = "50vh" as const
export const ALL_EMPLOYEES_VALUE = "ALL_EMPLOYEES" as const

// Error messages with consistent German language
export const ERROR_MESSAGES = {
  NO_PROJECTS: "Keine Projekte gefunden",
  NO_ASSIGNED_PROJECTS: "Sie haben keine zugewiesenen Projekte für den ausgewählten Mitarbeiter.",
  NO_PROJECTS_AVAILABLE: "Es sind keine Projekte vorhanden.",
  FETCH_ERROR: "Fehler beim Laden der Projekte:",
  FETCH_EMPLOYEES_ERROR: "Fehler beim Laden der Mitarbeiter:",
  PROJECT_NOT_FOUND: "Projekt nicht gefunden",
  NO_REPORTS_AVAILABLE: "Keine Berichte verfügbar",
  NO_EXAMINATIONS_FOR_STATUS: "Keine Untersuchungen für dieses Projekt",
  NO_RUNNING_EXAMINATIONS: "Keine laufenden Untersuchungen für dieses Projekt",
} as const

// Status labels for German UI
export const STATUS_LABELS = {
  OPEN: "offene",
  IN_PROGRESS: "laufende",
  DONE: "abgeschlossene",
  PAUSED: "pausierte",
  BILLED: "abgerechnete",
} as const

// Accessibility constants
export const A11Y_LABELS = {
  LOADING: "Projekte werden geladen",
  EMPLOYEE_SELECT: "Mitarbeiter auswählen",
  EMPLOYEE_SELECT_HELP: "Wählen Sie einen Mitarbeiter aus, um dessen zugewiesene Projekte anzuzeigen",
  PROJECT_SELECTOR: "Projekt auswählen",
  EMPTY_STATE: "Keine Projekte gefunden",
} as const